var _defs, _g, _g2, _g3, _g4, _g5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1084.85 834.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#E07A5F;}.cls-2{fill:#5B9BD5;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo_concept1_for_ae") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dot"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 792.43,
    cy: 292.43,
    r: 40
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "from_top_left"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "s_3",
    className: "cls-2",
    x: 233.78,
    y: 403.11,
    width: 60,
    height: 413.55,
    transform: "translate(-450.35 172.69) rotate(-45)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "from_bot_right"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "m_1",
    className: "cls-1",
    x: 546.2,
    y: 215.54,
    width: 60,
    height: 413.55,
    transform: "translate(-226.21 338.67) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "m_3",
    className: "cls-1",
    x: 983.78,
    y: 153.11,
    width: 60,
    height: 413.55,
    transform: "translate(-53.9 629.8) rotate(-45)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "from_top_right"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "m_2",
    className: "cls-1",
    x: 557,
    y: 329.89,
    width: 413.55,
    height: 60,
    transform: "translate(-127.13 453.02) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "m_4",
    className: "cls-1",
    x: 807,
    y: 579.89,
    width: 413.55,
    height: 60,
    transform: "translate(-230.68 703.02) rotate(-45)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "from_bot_left"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "s_1",
    className: "cls-2",
    x: 57,
    y: 329.89,
    width: 413.55,
    height: 60,
    transform: "translate(-273.57 99.47) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "s_2",
    className: "cls-2",
    x: 57,
    y: 829.89,
    width: 413.55,
    height: 60,
    transform: "translate(-627.13 245.91) rotate(-45)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.db1a3129d05cc6b69def2882fc19f56a.svg";
export { ForwardRef as ReactComponent };